export class Tones {

    static raise_octave = tone => tone + 12;
    static lower_octave = tone => tone - 12;
    static raise_fifth = tone => tone + 7;
    static lower_fifth = tone => tone - 7;
    static raise_fourth = tone => tone + 5;
    static lower_fourth = tone => tone - 5;
    static raise_major_third = tone => tone + 4;
    static lower_major_third = tone => tone - 4;
    static raise_minor_third = tone => tone + 3;
    static lower_minor_third = tone => tone - 3;
    
}

export default Tones;
